import { ref, toRefs, watch } from 'vue'

export default {
  props: ['icon', 'placeholder', 'label', 'modelValue', 'type', 'options'],
  emits: ['update:modelValue'],
  setup(props: any, { emit } : any) {
    const icon = ref(props.icon)
    const label = ref(props.label)
    const placeholder = ref(props.placeholder)
    const { modelValue, options } = toRefs(props)
    const type = ref(props.type)
    const input = ref(modelValue.value)

    watch(input, (newValue) => {
      emit('update:modelValue', newValue)
    })

    return {
      icon,
      label,
      input,
      type,
      placeholder,
      options
    }
  }
}
